import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Alert } from '../../../components/other/Alert';

import { ROLE_PERMISSIONS, POS_TYPE } from '../../../../common/constants';
import { analyseCoinMech } from '../../../../common/utils/vending-utils';
import { getFullMachineName } from '../../../../common/utils/machine';
import { useUserContext } from '../../../../common/utils/context';

import { Icon } from '../../../components';

import DocketDetailItem from '../DocketDetailItem';

// Coin mech data is hidden for markets, offline machines and users without the permission.
export const canShowDocketCoinMech = (machine, canViewMachineCoinMechData) => Boolean(machine?.hasCoinMech &&
	machine.type !== POS_TYPE.MARKET &&
	canViewMachineCoinMechData &&
	machine.commDevices?.length);

export const openDocketCoinMech = (navigation, machine, analysedCoinMech, docketId) => {
	// If there's no data, show an alert and don't allow going to the coin mech page
	if (analysedCoinMech.noCoinMechData) {
		Alert.alert(
			'No coin mech data',
			'There is no coin mech data to show. It is likely the machine has not yet sent any data, since being set up in the system, or the machine is intended as an off-line machine',
			[
				{ text: 'Ok', onPress: () => console.log('OK Pressed') },
			],
			{ cancelable: false },
		);
	}
	else {
		navigation.push('CoinMechDetail', {
			docketId,
			analysedCoinMech,
			lastCommunication: machine.lastCommunication,
			machineName: getFullMachineName(machine, machine.place, machine.location),
		});
	}
};

const DocketCoinMechDetail = ({ docket }) => {

	const navigation = useNavigation();
	const { hasPermission, tenantSettings } = useUserContext();

	const canViewMachineCoinMechData = hasPermission(ROLE_PERMISSIONS.VIEW_MACHINE_COIN_MECH);

	const { machine } = docket;

	// Note: coinmechDetail should always exist; tubesDetail may be null
	const { tubesDetail } = machine.coinMechDetail;
	const analysedCoinMech = analyseCoinMech(tubesDetail, machine.coinMech, tenantSettings, machine);

	return (
		<View>
			{
				canShowDocketCoinMech(machine, canViewMachineCoinMechData) && (
					<DocketDetailItem
						label="Coin mech"
						warning={analysedCoinMech.mechRequiresFill}
						subLabel={analysedCoinMech.label}
						onPress={() => openDocketCoinMech(navigation, machine, analysedCoinMech)}
						rightLabel={
							<Icon name="alert" size={24} color="#000" />
						}
					/>
				)
			}
		</View>
	);
};

export default DocketCoinMechDetail;
